import React, { Component } from 'react';
import { Container, Grid, GridColumn, Dropdown, Icon, Popup, Dimmer, Loader } from 'semantic-ui-react';
import './MessengerContainer.less'
import { ChatList, MessageList, Input } from 'react-chat-elements'
import { getChatUsers, getSMSChatByUserPhone, sendSMSToMessengerUser } from '../../services/Manager';
import { getNameInitials } from 'helpers/parseName';
import ErrorBox from '../../components/ErrorBox/ErrorBox';
import errorImg from '../../assets/images/newui/error-cross.svg'
import moment from 'moment';
import { connect } from 'react-redux';
import { formatPhone, unFormatPhone } from '../../helpers/parsePhone';
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import {SocketContext} from '../../context/socket';
import { UPDATE_MESSENGER_USERS_LIST , ON_INCOMING_SMS_RECEIVED , ON_SMS_STATUS_UPDATED , ON_SMS_RECEIVED} from 'constants/socketIOListener';
import { checkManagerAuthorization } from 'helpers/authorization';
import featuresList from '../../constants/FeaturesList';


let ApiCallInterval;
let smsUserAPICallInterval;

const initialStates = {
  smsUserList: [],
  selectedUser: "",
  orignalChatData:[],
  chatDataToShow: [],
  chatLoading: false,
  userLoading: false,
  messageText: "",
  enableMessaging: true,
  disableSendBtn: false,
  showError: false,
  inputFieldKey: 1,
  lastQueryDate: moment(),
  errorMessage: "Unable to send message. Please try again later, this number may be invalid.",
  selectedChatImagesURI : ""
}

class MessengerContainer extends Component {
  static contextType = SocketContext
  constructor(props) {
    super(props);
    this.state = { ...initialStates };
  }

  componentDidMount = () => {
    const socket = this.context
    this.onLoad()
    this.implementWebSockets(socket);
  }

  componentDidUpdate = (prevProps , prevStates) => {
    if(this.state.selectedUser && prevStates.selectedUser.phone != this.state.selectedUser.phone)
    {
      const socket = this.context
      this.implementWebSockets(socket);
      // console.log("component updated");
    }   
  }

  implementWebSockets = (socket) => {
    // socket.on(UPDATE_MESSENGER_USERS_LIST, (res) => {
    //   this.getMessengerUser()
    // });

    socket.on( UPDATE_MESSENGER_USERS_LIST, (newMessage) => {
      //console.log( "user list" , newMessage);


      let isShowHiddenSms = checkManagerAuthorization(featuresList.SHOW_HIDDEN_OUTGOING_SMS, this.props.currentUser);
      let skipSMS = false;

      if (newMessage.isHidden && newMessage.isHidden == true) {
        skipSMS = true;
        if (isShowHiddenSms) {
          skipSMS = false;
        }
      }

      if (!skipSMS) {
        // incomming new sms 
        if (newMessage.status == "received") {
          let updatedUsers = this.state.smsUserList.filter((user) => { return user.phone == newMessage.fromPhone });
          let otherRemainingUsers = this.state.smsUserList.filter((user) => { return user.phone != newMessage.fromPhone });

          // console.log("updated" ,updatedUsers);
          // console.log("other" ,otherRemainingUsers);

          if (updatedUsers.length > 0) {
            updatedUsers = updatedUsers.map((user) => {
              user["lastSMSBody"] = newMessage.body;
              user["lastSMSType"] = "incoming";
              user["originalTextDate"] = newMessage.originalTextDate;
              return user;
            });
          } else if (updatedUsers.length == 0 && newMessage.userData) {
            updatedUsers.push({
              lastSMSBody: newMessage.body,
              lastSMSType: "incoming",
              lastUserRequest: newMessage.userData.lastUserRequest,
              name: newMessage.userData.name,
              originalTextDate: newMessage.originalTextDate,
              phone: newMessage.fromPhone,
              userID: newMessage.userData.userID,
              userType: newMessage.userData.userType,
            });
          }

          // console.log("updated user after update : , " , updatedUsers);
          this.setState({ smsUserList: [...updatedUsers, ...otherRemainingUsers] })
        } else if (newMessage.status == "sent" || newMessage.status == "failed") {
          let updatedUsers = this.state.smsUserList.filter((user) => { return user.phone == newMessage.toPhone });
          let otherRemainingUsers = this.state.smsUserList.filter((user) => { return user.phone != newMessage.toPhone });

          // console.log("updated", updatedUsers);
          // console.log("other", otherRemainingUsers);
          if (updatedUsers.length > 0) {
            updatedUsers = updatedUsers.map((user) => {
              user["lastSMSBody"] = newMessage.body;
              user["lastSMSType"] = "outgoing";
              user["originalTextDate"] = newMessage.originalTextDate;
              return user;
            });
          } else if (updatedUsers.length == 0 && newMessage.userData) {
            updatedUsers.push({
              lastSMSBody: newMessage.body,
              lastSMSType: "outgoing",
              lastUserRequest: newMessage.userData.lastUserRequest,
              name: newMessage.userData.name,
              originalTextDate: newMessage.originalTextDate,
              phone: newMessage.toPhone,
              userID: newMessage.userData.userID,
              userType: newMessage.userData.userType,
            });
          }

          // console.log("updated user after update : , " , updatedUsers);
          this.setState({ smsUserList: [...updatedUsers, ...otherRemainingUsers] })
        }
      }
    });

    if (this.state.selectedUser.phone) {
      let key = ON_SMS_RECEIVED.replace("<PHONE_NO>", this.state.selectedUser.phone);
      socket.on(key, (messages) => {

        let newMsgs = [...this.state.chatDataToShow];
        let orignalSmsData = [...this.state.orignalChatData];

        let isShowHiddenSms = checkManagerAuthorization(featuresList.SHOW_HIDDEN_OUTGOING_SMS, this.props.currentUser);
        let skipSMS = false;

        messages.forEach((msg) => {

          if (msg.isHidden && msg.isHidden == true) {
            skipSMS = true;
            if (isShowHiddenSms) {
              skipSMS = false;
            }
          }

          if ((this.state.selectedUser.phone == msg.fromPhone || this.state.selectedUser.phone == msg.toPhone) && (!skipSMS)) {
            
            this.getMappedMessages([{
              ...msg,
              fromUserFirstName: msg.fromUserFirstName,
              fromUserLastName: msg.fromUserLastName,
              message: msg.body,
              smsDate: msg.originalTextDate,
              smsType: "received",
              status: msg.status
            }]).map((sms) => {
              newMsgs.push(sms);
            })
            
            // newMsgs.push(this.getMappedMessages())
            
            // newMsgs.push(this.getMessageObject({
            //   ...msg,
            //   fromUserFirstName: msg.fromUserFirstName,
            //   fromUserLastName: msg.fromUserLastName,
            //   message: msg.body,
            //   smsDate: msg.originalTextDate,
            //   smsType: "received",
            //   status: msg.status
            // }));
            orignalSmsData.push({
              ...msg,
              fromUserFirstName: msg.fromUserFirstName,
              fromUserLastName: msg.fromUserLastName,
              message: msg.body,
              smsDate: msg.originalTextDate,
              smsType: "received",
              status: msg.status
            })
          }
        });
        this.setState({ chatDataToShow: [...newMsgs] , orignalChatData: [...orignalSmsData] }, () => {
          setTimeout(() => {
            this.scrollDivToBottom();
          }, 30);
        })
      });
    }

    if (this.state.selectedUser.phone) {
      let key = ON_SMS_STATUS_UPDATED.replace("<PHONE_NO>", this.state.selectedUser.phone);
      // console.log(key);
      socket.on(key, (response) => {
        // console.log("status update hit , ", response)
        // debugger;
        let orignalChatData = this.state.orignalChatData;
        if (orignalChatData.length > 0) {
          let SMSIndex = orignalChatData.findIndex((item) => {
            return item.messageSID == response.messageSID
          });
          if (SMSIndex != -1) {
            orignalChatData[SMSIndex]['status'] = response.messageStatus
          }

          let chatDataToShow = this.state.chatDataToShow;
          if (chatDataToShow.length > 0) {
            let chatMsgIndex = chatDataToShow.findIndex((item) => {
              return item.messageSID == response.messageSID
            });
            if (chatMsgIndex != -1) {
              chatDataToShow[chatMsgIndex] = this.getMessageObject(orignalChatData[SMSIndex]);
            }
          }
          this.setState({ chatDataToShow: [...chatDataToShow], orignalChatData: [...orignalChatData] })
        }
      });
    }

  }
  componentWillUnmount = () => {
    clearInterval(ApiCallInterval);
  }

  onLoad = async () => {
    this.setState({ userLoading: true }, () => {
      setTimeout(async () => {
        // load user first time.
        // this.getMessengerUser()
        let chatUsers = await getChatUsers();
        if (chatUsers.resStatus == 200) {
          this.setState({ smsUserList: [...chatUsers.data], userLoading: false })
        }

        // smsUserAPICallInterval = setInterval(async () => {
        //   let chatUsers = await getChatUsers();
        //   if (chatUsers.resStatus == 200) {
        //     this.setState({ smsUserList: [...chatUsers.data] })
        //   }
        // }, 6000)
      }, 10)
    });
  }

  // getMessengerUser = async () => {
  //   let chatUsers = await getChatUsers();
  //   if (chatUsers.resStatus == 200) {
  //     this.setState({ smsUserList: [...chatUsers.data], userLoading: false })
  //   }
  // }

  handleUserClick = async (e, user) => {
    if (ApiCallInterval) {
      clearInterval(ApiCallInterval)
    }
    this.setState({ selectedUser: user, chatLoading: true
      //, chatDataToShow: [] 
    }, () => {
      setTimeout(async () => {
        let response = await getSMSChatByUserPhone(user.phone, this.state.lastQueryDate)
        let dataToShow = [];
        if (response.resStatus == 200) {
          // response.data.forEach((message) => {
          //   dataToShow.push(this.getMessageObject(message))
          // });

          dataToShow = [...this.getMappedMessages(response.data)]

          this.setState({ orignalChatData: [...response.data] , chatDataToShow: [...dataToShow], chatLoading: false, lastQueryDate: moment() })
        }

        setTimeout(() => {
          this.scrollDivToBottom();
        }, 10);

        // ApiCallInterval = setInterval(async () => {
        //   let response = await getSMSChatByUserPhone(this.state.selectedUser.phone, this.state.lastQueryDate)
        //   let dataToShow = [];
        //   if (response.resStatus == 200) {
        //     response.data.forEach((message) => {
        //       dataToShow.push(this.getMessageObject(message))
        //     });
        //     this.setState({ chatDataToShow: [...dataToShow], 
        //       // chatLoading: false, 
        //       lastQueryDate: moment() })
        //   }
        // }, 5000)

      }, 10);
    })
  }

  getTimeStamp = (date) => {
    try {
      return moment(new Date(date)).format('MM/DD/YY HH:mm:ss');
    } catch (ex) {
      return "Invalid Date";
    }
  }

  getErrorTitle = () => {
    return <>
      <div style={{ display: "flex" }}>
        <img src={errorImg}></img>
        <p className={"error-status-text"}> {"Delivery Failed"}
        </p>
      </div>
    </>
  }

  getMappedMessages = (dataToShow) => {
    let data = [];
    dataToShow.forEach((message) => {
        if(!message.media)
        {
            data.push(this.getMessageObject(message,true))
        }

        if(message.media && message.media.length == 1)
        {
            data.push(this.getMessageObject(message,true))
        }else if (message.media && message.media.length > 1)
        {
            message.media.forEach((media) => {
                data.push(this.getPhotoMessageObject(media,message))

            })
            data.push(this.getMessageObject(message,false))
        }            
    });
    return data;
  }

  // getMessageoldObject = (Message) => {
  //   let messageObject = {
  //     text: <>
  //       <p className={"message-paragraph"}> {Message.message}</p>
  //       {
  //         Message.status != "received" ?
  //           <div className={"message-sender"}>
  //             {Message.fromUserFirstName ? Message.fromUserFirstName + ", " + getNameInitials(Message.fromUserLastName, 2) : "System Generated"}
  //           </div>
  //           : ""
  //       }
  //     </>,
  //     position: Message.status === "received" ? "left" : "right",
  //     type: 'text',
  //     date: new Date(Message.smsDate),
  //     dateString: this.getTimeStamp(Message.smsDate),
  //     messageSID: Message.messageSID,
  //     title: ((Message.status === 'failed' || Message.status === 'undelivered') ? this.getErrorTitle() : ""),
  //     titleColor: (Message.status === 'failed' || Message.status === 'undelivered') ? "red" : "",
  //     className: (Message.status === 'failed' || Message.status === 'undelivered') ? "error-box" : ""
  //   }

  //   if (Message.media) {
  //     messageObject = {
  //         ...messageObject,
  //         type: "photo",
  //         data: {
  //             uri: Message.media.URL,
  //             status: {
  //                 // download:false,
  //                 // click: true,
  //                 // loading: 0,
  //             }
  //         },
  //         onClick: (e) => {
  //             console.log("click ", e);
  //         }
  //       }
  //   }

  //   return messageObject;
  // }

  getMessageObject = (Message , checkMedia=false) => {
    let messageObject = {
        text: <>
            {
                Message.message.length ?
                    <p className={"message-paragraph"}> {Message.message}</p> : ""
            }

            {
                Message.status != "received" ?
                    <div className={"message-sender"}>
                        {Message.fromUserFirstName ? Message.fromUserFirstName + ", " + getNameInitials(Message.fromUserLastName, 2) : "System Generated"}
                    </div>
                    : ""
            }
        </>,
        position: Message.status === "received" ? "left" : "right",
        type: 'text',
        date: new Date(Message.smsDate),
        dateString: this.getTimeStamp(Message.smsDate),
        messageSID: Message.messageSID,
        smsID: Message.smsID,
        title: ((Message.status === 'failed' || Message.status === 'undelivered') ? this.getErrorTitle() : ""),
        titleColor:(Message.status === 'failed' || Message.status === 'undelivered') ? "red" : "",
        className: (Message.status === 'failed' || Message.status === 'undelivered') ? "error-box" : "",
        removeButton:  Message.status == "received" && this.state.smsDeletionEnabled ?  true : false,    
    }

    if ( checkMedia && Message.media && Message.media.length) {
        messageObject = {
            ...messageObject,
            type: "photo",
            data: {
                // width : '100%',
                // height: '100%',
                uri: Message.media[0].URL,
                status: {
                    // download:false,
                    click: true,
                    // loading: 0,
                }
            },
            onClick: (e) => {
                console.log("click ", e);
            }
        }
    }

    return messageObject;
  }

  getPhotoMessageObject = (mediaObject ,Message ) => {

    let messageObject = {
        // text: "",
        position: Message.status === "received" ? "left" : "right",
        type: "photo",
        date: new Date(Message.smsDate),
        // dateString: this.getTimeStamp(Message.originalTextDate),
        dateString: this.getTimeStamp(Message.smsDate),
        smsID: Message.smsID,
        messageSID: Message.messageSID,
        // title: ((Message.status === 'failed' || Message.status === 'undelivered') ? this.getErrorTitle() : ""),
        // titleColor:(Message.status === 'failed' || Message.status === 'undelivered') ? "red" : "",
        // className: (Message.status === 'failed' || Message.status === 'undelivered') ? "error-box" : "",
        data: {
            // width : '100%',
            // height: '100%',
            uri: mediaObject.URL,
            status: {
                // download:false,
                click: true,
                // loading: 0,
            }
        }
    }
    return messageObject;
  }

  scrollOnError = () => {
    let element = document.getElementById("error-box-container-id");
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        inline: 'center'
      });
    }
  }

  scrollDivToBottom = () => {
    if (window.innerWidth > 768) {
      var elements = document.getElementsByClassName("rce-container-mbox");
      if (elements.length) {
        let element = elements[elements.length - 1];
        element.scrollIntoView({
          behavior: 'smooth',
          inline: 'center'
        });
      }
    }
  }

  valueChange = (e) => {
    this.setState({
      messageText: e.target.value,
      showError: e.target.value.length == 0 ? false : this.state.showError
    })
  }

  sendMessage = async (e) => {
    if (this.state.messageText.length > 0 && !this.state.disableSendBtn) {
      this.setState({ disableSendBtn: true, showError: false })
      //const singleBuyerRequestID = this.props.singleBuyerRequestID;
      let selectedUser = this.state.selectedUser
      let messagesResponse;
      if (selectedUser) {
        messagesResponse = await sendSMSToMessengerUser(selectedUser.phone, this.state.messageText, selectedUser.userType, selectedUser.userID)

        if (messagesResponse.resStatus == 200) {
          // let newMesseg = {
          //   position: 'right',
          //   type: 'text',
          //   text: 
          //   <>
          //     <p className={"message-paragraph"}> {messagesResponse.data.message.body}</p>            
          //         <div className={"message-sender"}>
          //           {this.props.currentUser.firstName + ", " + getNameInitials(this.props.currentUser.lastName, 2)}
          //         </div>
          //   </>,
          //   date: new Date(messagesResponse.data.message.originalTextDate),
          //   dateString: this.getTimeStamp(messagesResponse.data.message.originalTextDate),
          //   title: ((messagesResponse.data.message.status === 'failed' || messagesResponse.data.message.status === 'undelivered') ? this.getErrorTitle() : ""),
          //   titleColor: (messagesResponse.data.message.status === 'failed' || messagesResponse.data.message.status === 'undelivered') ? "red" : "",
          //   className: (messagesResponse.data.message.status === 'failed' || messagesResponse.data.message.status === 'undelivered') ? "error-box" : "",
          //   messageSID: messagesResponse.data.message.messageSID,
          // }
          // let updatedData = this.state.chatDataToShow;
          // updatedData.push(newMesseg);

          // let updatedOrignalData = this.state.orignalChatData;
          // updatedOrignalData.push({
          //   fromUserFirstName: this.props.currentUser.firstName,
          //   fromUserLastName: this.props.currentUser.lastName,
          //   message: messagesResponse.data.message.body,
          //   messageSID: messagesResponse.data.message.messageSID,
          //   smsDate: messagesResponse.data.message.originalTextDate,
          //   smsType: "sent",
          //   status: messagesResponse.data.message.status
          // })


          // reoload chat user list
          // this.getMessengerUser();

          this.setState({
            // chatDataToShow: updatedData,
            // orignalChatData: updatedOrignalData,
            messageText: "", 
            inputFieldKey: this.state.inputFieldKey + 1,
            lastQueryDate: moment()
          });
          // setTimeout(() => {
          //   this.scrollDivToBottom();
          // }, 1);
        } else {
          this.setState({ showError: true })
          this.scrollOnError();
        }
      }
      this.setState({ disableSendBtn: false })
    }
  }

  handleRequestIDClick = (requestID) => {
    // this.props.history.push('/request/' + ids.singleBuyerRequestID)
    const win = window.open('/request/' + requestID, "_blank");
    win.focus();
  }

  
  isUserSelected = (user) => {
    let selectdUser = this.state.selectedUser;
    return selectdUser.phone == user.phone && selectdUser.userID == user.userID && selectdUser.userType == user.userType;
  }

  downloadChatImage = (e) => {        
    if( e.data && e.data.uri && e.data.uri.length)
    {
        this.setState({ selectedChatImagesURI:  e.data.uri })
    }   
  }

  render() {
    return (
      <Container fluid className='messenger-container'>
        <Grid>
          <Grid.Row>
            <Grid.Column width={4} style={{ paddingRight: '0px' }}>
              <div className={`seller-buyer-list-container-outer`}>
                {
                  this.state.userLoading ? <Loader active={true} size='massive'> </Loader> :
                    <div className={`seller-buyer-list-container`}>
                      {
                        this.state.smsUserList && this.state.smsUserList.length ?
                          this.state.smsUserList.map((user,userIndex) => {
                            return (
                              <div key={`sms-user-key-${userIndex}`} className={`seller-buyer-list-item ${this.isUserSelected(user) ? "active" : ""}`} onClick={this.isUserSelected(user) ? () => { } : (e) => { this.handleUserClick(e, user) }}>
                                <div className={`avatar-container`} >
                                  <div className={`avatar`}
                                  // style={{ background: `rgba(${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, ${Math.floor(Math.random() * 257)}, 1)` }} 
                                  >
                                    {
                                      getNameInitials(user.name, 2)
                                    }
                                  </div>
                                  <div className={`user-type ${user.userType == "buyer" ? "buyer" : "seller"}`}>
                                    {
                                      user.userType == "buyer" ? "Buyer" : "Seller"
                                    }
                                  </div>
                                </div>
                                <div className={`title-container`}>
                                  <div className={`title-time-container`}>
                                    <div className={`title`}>
                                      {
                                        user.name
                                      }
                                    </div>
                                    <div className={"time"}>
                                      {
                                        moment(new Date(user.originalTextDate)).format('MM/DD/YY HH:mm A')
                                      }
                                    </div>
                                  </div>
                                  <div className={`user-phone`}>
                                    {
                                      formatPhone(user.phone.substring(2))
                                    }
                                  </div>
                                  <div className={`lastSMSBody`}>
                                    <p>
                                      {
                                        user.lastSMSBody
                                      }
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                          : ""
                      }
                    </div>
                }
              </div>
            </Grid.Column>
            {
              this.state.selectedUser ?
                <Grid.Column width={12} style={{ paddingLeft: '0px' }}>
                  <Grid.Row className={`heading-container`}>
                    <div className={`heading-avatar-container`}>
                      <div className={`avatar`}>
                        {getNameInitials(this.state.selectedUser.name, 2)}
                      </div>
                      <div className={`heading`}>
                        {this.state.selectedUser.name}
                      </div>
                      <div className={`user-mobile`}>

                        <a href={`tel:${formatPhone(this.state.selectedUser.phone.substring(2))}`}>
                          <Icon name='phone' className="seller-phone-icon"> </Icon></a>
                        {!_.isEmpty(this.state.selectedUser.phone) ? `(${formatPhone(this.state.selectedUser.phone.substring(2))})` : ''}

                      </div>
                      <div className={`user-request-ids`}>
                        <div> <strong>{"Requests : "}</strong> </div>
                        {

                          this.state.selectedUser.lastUserRequest.map((ids) => {
                            return <div className={"request-id"} onClick={() => { this.handleRequestIDClick(ids.singleBuyerRequestID) }} >
                              {ids.singleBuyerRequestID + ","}
                            </div>
                          })
                        }
                      </div>

                    </div>
                    {/* <div className={`icon-container`}>
                      <div className={`icon`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                          <g id="ic_Member" transform="translate(-0.118 -0.006)">
                            <g id="ic_Member-2" data-name="ic_Member" transform="translate(0.118 0.006)">
                              <path id="Shape" d="M17.93,20H4.07A4.077,4.077,0,0,1,0,15.926V4.074A4.077,4.077,0,0,1,4.07,0H17.93A4.077,4.077,0,0,1,22,4.074V15.926A4.077,4.077,0,0,1,17.93,20ZM4.07,2.222A1.863,1.863,0,0,0,2.2,4.074V15.926a1.863,1.863,0,0,0,1.87,1.852H17.93a1.863,1.863,0,0,0,1.87-1.852V4.074a1.863,1.863,0,0,0-1.87-1.852ZM9.216,15.558A1.5,1.5,0,0,1,7.883,14.7a1.766,1.766,0,0,1-.183-.788V6.085A1.567,1.567,0,0,1,9.209,4.444a1.449,1.449,0,0,1,.924.34L14.815,8.7a1.754,1.754,0,0,1,.4,2.088,1.6,1.6,0,0,1-.4.514l-4.682,3.915A1.419,1.419,0,0,1,9.216,15.558ZM9.9,7.475v5.05L12.921,10Z" fill="#92929d" />
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className={`icon`}>
                        <svg id="ic_Favoutire" xmlns="http://www.w3.org/2000/svg" width="19.106" height="20.006" viewBox="0 0 19.106 20.006">
                          <path id="Shape" d="M8.743,17.879,2,10.782A7.322,7.322,0,0,1,0,5.71,7.322,7.322,0,0,1,2,.637,1.957,1.957,0,0,1,3.4,0,1.455,1.455,0,0,1,4.476.464l3.609,3.8c.553.583.452,1.005-.434,3.373-.248.555-.188.983-.02,1.159l3.139,3.3a.491.491,0,0,0,.365.129,1.593,1.593,0,0,0,.67-.186,8.225,8.225,0,0,1,2.477-.816,1.02,1.02,0,0,1,.794.4l3.61,3.8a1.775,1.775,0,0,1-.165,2.457,6.684,6.684,0,0,1-9.779,0ZM2,5.8A5.338,5.338,0,0,0,3.45,9.4l6.743,7.1a4.681,4.681,0,0,0,6.818.062l-3.041-3.2c-.313.1-.777.272-1.34.5a3.412,3.412,0,0,1-1.493.366,2.442,2.442,0,0,1-1.816-.752L6.181,10.173A2.985,2.985,0,0,1,5.8,6.88c.253-.677.428-1.194.52-1.536,0-.008.005-.017.007-.025L3.322,2.154A5.356,5.356,0,0,0,2,5.8ZM17.1,8.206a6.2,6.2,0,0,0-6.2-6.2,1,1,0,0,1,0-2,8.2,8.2,0,0,1,8.2,8.2,1,1,0,1,1-2,0Zm-2.7,0a3.5,3.5,0,0,0-3.5-3.5,1,1,0,0,1,0-2,5.5,5.5,0,0,1,5.5,5.5,1,1,0,0,1-2,0Zm-2.7,0a.8.8,0,0,0-.8-.8,1,1,0,0,1,0-2,2.8,2.8,0,0,1,2.8,2.8,1,1,0,0,1-2,0Z" fill="#92929d" />
                        </svg>
                      </div>
                      <div className={`icon`}>
                        <svg id="ic_Settings" xmlns="http://www.w3.org/2000/svg" width="18" height="4" viewBox="0 0 18 4">
                          <path id="Shape" d="M0,16a2,2,0,1,1,2,2A2,2,0,0,1,0,16ZM0,9a2,2,0,1,1,2,2A2,2,0,0,1,0,9ZM0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z" transform="translate(0 4) rotate(-90)" fill="#92929d" />
                        </svg>
                      </div>
                    </div> */}
                  </Grid.Row>
                  {
                    this.state.chatLoading ? <Loader active={true} size='massive'> </Loader>
                      :
                      <Grid.Row className={`message-container ${ this.state.selectedUser.userType == "seller" ? "" : 'no-input-text'}`}>
                        <MessageList
                          className={`message-list`}
                          lockable={true}
                          toBottomHeight={'100%'}
                          downButton={true}
                          // onDownload={(e) => {this.downloadChatImage(e)}}
                          onClick={(e) => {this.downloadChatImage(e)}}
                          dataSource={
                            [
                              ...this.state.chatDataToShow,
                            ]
                          }
                        />
                        {/* 
                        
                    <div className={`input-container ${this.props.isExpand ? "expand" : ""}`}>
                      {
                        <div className={`snippets-modal-container ${this.props.isSnippetsOpen ? "show" : ""}`}>
                          {
                            this.props.isSnippetsOpen &&
                              !this.state.isSnippetsLoaded ?
                              <Dimmer active={true}>
                                <Loader active={true} size='massive'> </Loader>
                              </Dimmer>
                              :
                              <div className={'snippets-modal-inner-container'} >
                                <ChatSnippets key={"chatSnippets-key-" + this.props.singleBuyerRequestID} chatCnippetsData={this.state.chatSnippetsData} onSnippetSelect={this.onSnippetSelect} />
                              </div>
                          }
                          <svg className={"bottom-notch"} xmlns="http://www.w3.org/2000/svg" width="16.376" height="10.078" viewBox="0 0 16.376 10.078">
                            <path id="Polygon_9" data-name="Polygon 9" d="M8.188,0l8.188,10.078H0Z" transform="translate(16.376 10.078) rotate(180)" fill="#fef5e2" />
                          </svg>
                        </div>
                      }
                      <Input
                        className={"message-input"}
                        placeholder="Write your message here …"
                        ref={this.inputField}
                        key={"inputField-" + this.state.inputFieldKey}
                        multiline={true}
                        minHeight={60}
                        defaultValue={this.state.messageText}
                        onChange={(e) => { this.valueChange(e) }}
                        maxlength={2048}
                        rightButtons={
                          this.state.enableMessaging &&
                          <>
                            <div className={"actions-container"}>
                              <div onClick={() => this.toggleSnippets()} className={"attahcment-icon-container"} data-tooltip={`Snippets`} data-position="top center" data-inverted="" >

                                <svg className={`attahcment-icon ${this.props.isSnippetsOpen ? "highlighted" : ""} `} xmlns="http://www.w3.org/2000/svg" width="25.781" height="25.774" viewBox="0 0 25.781 25.774">
                                  <defs>
                                    <clipPath id="clip-path">
                                      <rect id="Rectangle_8827" data-name="Rectangle 8827" width="25.781" height="25.774" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                    </clipPath>
                                  </defs>
                                  <g id="Group_15949" data-name="Group 15949" clip-path="url(#clip-path)">
                                    <path id="Path_29303" data-name="Path 29303" d="M0,12.873Q0,6.82,0,.767C0,.166.169,0,.778,0H6.4a2.034,2.034,0,0,1,.265.007.563.563,0,0,1,.01,1.116,2,2,0,0,1-.289.012c-1.664,0-3.328,0-4.992,0-.195,0-.26.046-.26.252q.008,11.5,0,23.006c0,.2.061.255.258.254,1.664-.007,3.328,0,4.992,0a2.068,2.068,0,0,1,.289.011.558.558,0,0,1,.482.595.546.546,0,0,1-.55.527q-3.027,0-6.054,0a.535.535,0,0,1-.543-.505c-.008-.1,0-.193,0-.289q0-6.053,0-12.106" transform="translate(-0.001 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                    <path id="Path_29304" data-name="Path 29304" d="M392.62,12.905q0,6.041,0,12.082c0,.08,0,.161,0,.241a.545.545,0,0,1-.572.554q-3,0-6.006,0a.547.547,0,0,1-.573-.528.553.553,0,0,1,.527-.6c.12-.011.241-.006.361-.006,1.624,0,3.248,0,4.872,0,.194,0,.261-.045.261-.252q-.008-11.5,0-23.007c0-.2-.063-.254-.259-.253q-2.52.011-5.041,0a1.054,1.054,0,0,1-.439-.087.534.534,0,0,1-.272-.612.572.572,0,0,1,.5-.426,2.092,2.092,0,0,1,.217,0h5.692c.551,0,.734.184.734.74q0,6.077,0,12.155" transform="translate(-366.839 -0.01)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                    <path id="Path_29305" data-name="Path 29305" d="M80.521,362.709h-8.8a.574.574,0,1,1-.111-1.142,1.661,1.661,0,0,1,.217,0q8.708,0,17.415,0a1.206,1.206,0,0,1,.4.057.56.56,0,0,1,.336.606.584.584,0,0,1-.5.479c-.072.007-.145,0-.217,0H80.521" transform="translate(-67.635 -344.092)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                    <path id="Path_29306" data-name="Path 29306" d="M80.547,149.3q-4.352,0-8.7,0a1.06,1.06,0,0,1-.478-.117.485.485,0,0,1-.242-.535.52.52,0,0,1,.384-.45,1.267,1.267,0,0,1,.333-.039q8.728,0,17.455,0a1.01,1.01,0,0,1,.518.14.482.482,0,0,1,.192.555.575.575,0,0,1-.491.438,1.5,1.5,0,0,1-.265.008h-8.7" transform="translate(-67.679 -140.991)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                    <path id="Path_29307" data-name="Path 29307" d="M78.83,254.732H85.8a2.156,2.156,0,0,1,.241,0,.573.573,0,0,1,.529.584.589.589,0,0,1-.528.565,1.874,1.874,0,0,1-.217,0H71.861c-.072,0-.145,0-.217,0a.594.594,0,0,1-.543-.576.579.579,0,0,1,.541-.574,2.38,2.38,0,0,1,.241,0H78.83" transform="translate(-67.666 -242.424)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                  </g>
                                </svg>
                              </div>
                              <div className={`send-icon-container`} data-tooltip={`Send message`} data-position="top center" data-inverted="" onClick={(e) => { this.state.disableSendBtn || !this.state.enableMessaging ? null : this.sendMessage(e) }} >
                                <svg className={`send-icon ${this.state.disableSendBtn || this.state.messageText.length == 0 ? "disabled" : ""}`} xmlns="http://www.w3.org/2000/svg" width="31.001" height="31.001" viewBox="0 0 31.001 31.001">
                                  <path id="direct" d="M21.885.927l-6.7,20.507a.708.708,0,0,1-1.283.136L9.4,13.82a.707.707,0,0,1,.043-.777l1.618-2.178L8.878,12.483a.707.707,0,0,1-.777.043L.351,8.02A.708.708,0,0,1,.487,6.736L20.994.035a.708.708,0,0,1,.892.892Z" transform="translate(15.5) rotate(45)" fill="#377dff" />
                                </svg>
                              </div>
                            </div>
                          </>
                        } />
                    </div> */}
                        {/* {
                                    this.state.showError ? <div id={"error-box-container-id"} className={"error-container-box"}>
                                        <ErrorBox message={this.state.errorMessage} />
                                    </div> : null
                                } */}

                      </Grid.Row>
                  }

                {
                  this.state.selectedUser.userType == "seller" ? 
                
                  <Grid.Row className={"input-container"}>
                    <div className={`icon`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <defs>
                          <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0" stop-color="#e8ecff" />
                            <stop offset="1" stop-color="#fff" />
                          </linearGradient>
                        </defs>
                        <g id="Group_16087" data-name="Group 16087" transform="translate(-1368 -348)">
                          <g id="automotive-logo-vector_25327-6" transform="translate(1368 348)" stroke="#f1f1f5" stroke-width="1" fill="url(#linear-gradient)">
                            <rect width="32" height="32" rx="16" stroke="none" />
                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="none" />
                          </g>
                          <g id="Group_16085" data-name="Group 16085" transform="translate(1373.623 353.16)">
                            <path id="Path_28734" data-name="Path 28734" d="M7426.631-510.609a12.671,12.671,0,0,1-10.154-5.18,1.2,1.2,0,0,1-.2-1.246,4.1,4.1,0,0,1,1.523-1.94,14.248,14.248,0,0,1,5.367-2.251,15.953,15.953,0,0,1,11.427,1.651,9.763,9.763,0,0,1,1.822,1.445,2.531,2.531,0,0,1,.516.783,1.411,1.411,0,0,1-.15,1.687A12.753,12.753,0,0,1,7426.631-510.609Z" transform="translate(-7416.19 533.699)" fill="#657087" />
                            <path id="Path_28735" data-name="Path 28735" d="M7484.958-690.205a5.252,5.252,0,0,1,5.265,5.233,5.284,5.284,0,0,1-5.237,5.277,5.28,5.28,0,0,1-5.284-5.271A5.25,5.25,0,0,1,7484.958-690.205Z" transform="translate(-7474.479 690.205)" fill="#657087" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <Input
                      className={"message-input"}
                      placeholder="Write your message here …"
                      ref={this.inputField}
                      key={"inputField-" + this.state.inputFieldKey}
                      multiline={true}
                      minHeight={60}
                      defaultValue={this.state.messageText}
                      onChange={(e) => { this.valueChange(e) }}
                      maxlength={2048}
                      rightButtons={
                        this.state.enableMessaging &&
                        <>
                          <div className={"actions-container"}>
                            <div className={`send-icon-container`} data-tooltip={`Send message`} data-position="top center" data-inverted="" onClick={(e) => { this.state.disableSendBtn || !this.state.enableMessaging ? null : this.sendMessage(e) }} >
                              <svg className={`send-icon ${this.state.disableSendBtn || this.state.messageText.length == 0 ? "disabled" : ""}`} xmlns="http://www.w3.org/2000/svg" width="31.001" height="31.001" viewBox="0 0 31.001 31.001">
                                <path id="direct" d="M21.885.927l-6.7,20.507a.708.708,0,0,1-1.283.136L9.4,13.82a.707.707,0,0,1,.043-.777l1.618-2.178L8.878,12.483a.707.707,0,0,1-.777.043L.351,8.02A.708.708,0,0,1,.487,6.736L20.994.035a.708.708,0,0,1,.892.892Z" transform="translate(15.5) rotate(45)" fill="#377dff" />
                              </svg>
                            </div>
                          </div>
                        </>
                      } />
                  </Grid.Row>
                 : "" 
                 }
                  {
                    this.state.showError ? <div id={"error-box-container-id"} className={"error-container-box"}>
                      <ErrorBox message={this.state.errorMessage} />
                    </div> : null
                  }
                </Grid.Column>
                :
                ""
            }
          </Grid.Row>
        </Grid>
        {
          this.state.selectedChatImagesURI.length > 0 &&
          <Lightbox image={this.state.selectedChatImagesURI}
            // images={this.state.lbImages}
            onClose={() => this.setState({ selectedChatImagesURI: "" })}
          // startIndex={this.state.selectedLBImage}
          >
          </Lightbox>
        }
      </Container>
    );
  }
}

function mapStateToProps({ auth }) {
  //Whatever is returned from this function will end up
  // as props inside of this container component

  return {
      currentUser: auth.currentUser,
  }
}

export default connect(mapStateToProps)(MessengerContainer);

